import { stage } from 'config/stage';

const portal = {
    prd: 'https://portal.nextcloud.aero',
    test: 'https://portal-test.nextcloud.aero',
    dev: 'https://portal-dev.nextcloud.aero',
    cloud9: [process.env.REACT_APP_HOST, 8081].join(':'),
    ide: ['https://localhost', 8081].join(':'),
};

export default portal[stage];
